import React from 'react';
import { Divider, Box, Flex, Text, Image } from '@opendoor/bricks/core';
import { EventCard } from '@opendoor/cinderblocks/platform/EventCard';

import { useOfferContext } from 'sellDirect/OfferContext';
import { GetSellDirect_sellDirect_getLead_lead_experiencePartner } from 'sellDirect/graphql/__generated__/GetSellDirect';
import { formatPhoneNumber } from 'shared/helpers/formatters';
import { ExternalLink } from 'platform/react-router';

// component-test-check-ignore
/** TODO: Add documentation */
export const FinalizingOfferContentWithoutContext: React.FC<{
  experiencePartner?: GetSellDirect_sellDirect_getLead_lead_experiencePartner;
}> = ({ experiencePartner }) => {
  return (
    <Flex
      data-testid="finalizing-offer-content"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      height="100%"
    >
      <Box mb={8}>
        <EventCard
          chipOrIconProps={{ firstLine: '2-4', secondLine: 'DAYS' }}
          title="We're finalizing your offer"
        />
        <Text my={7}>
          An Opendoor Expert is reviewing your information now. We’ll email your final offer in 2-4
          days.
        </Text>
        <Divider />
        {experiencePartner && (
          <>
            <Flex my={7} alignItems="center">
              <Image
                mr={5}
                width={72}
                height={72}
                borderRadius="rounded"
                src={experiencePartner.photoUrl}
                alt={experiencePartner.name}
                aria-hidden
              />
              <Box>
                <Text fontWeight="semibold">{experiencePartner.name}</Text>
                <Text fontSize="s0">Opendoor Selling Expert</Text>
              </Box>
            </Flex>
            <ExternalLink
              analyticsName="cake-ep-phone-cta"
              aria-label={null}
              href={`tel:${experiencePartner.displayPhoneNumber}`}
              variant="secondary-button"
              fontSize="s1"
              fontWeight="semibold"
              height="56px"
            >
              {formatPhoneNumber(experiencePartner.displayPhoneNumber)}
            </ExternalLink>
          </>
        )}
      </Box>
    </Flex>
  );
};

// component-test-check-ignore
/** TODO: Add documentation */
export const FinalizingOfferContent: React.FC = () => {
  const { offer } = useOfferContext();

  if (!offer) {
    return null;
  }

  return (
    <FinalizingOfferContentWithoutContext
      experiencePartner={offer.experiencePartner ?? undefined}
    />
  );
};
